import React from 'react';
import Menu from './Menu';
import Header from './Header';
import { client } from '../App';

import $ from 'jquery';
import { QueryGetListAds } from "../GraphQL/MutationAds";
import { stripeAPI } from "../Lib/Utils";
import appSyncConfig from '../AppSync';
import Ads from './Ads';

class MainLayout extends React.Component {
	subCognito = localStorage.getItem('subHandsApps');
	constructor(props) {
		super(props);

		this.state = {
			isShowAds: false,
			listTHAds: [],
			listTLAds: [],
			listTRAds: [],
			listBLAds: [],
			listBRAds: [],
		};
	}

	adsData = async (e) => {
		const ads = await client.query({
			query: QueryGetListAds,
			fetchPolicy: 'network-only'
		});
		return ads;
	}

	loadAds() {
		var obj = this;
		this.adsData().then((ads) => {
			var items = ads.data.listAds.items;
			items = items.filter((item) => {
				var today = new Date().getTime();
				var start_time = new Date(item.start_time + ' 00:00:00').getTime();
				var end_time = new Date(item.end_time + ' 23:59:59').getTime();
				if (start_time > 0 && start_time > today)
					return false;
				if (end_time > 0 && end_time < today)
					return false;
					
				return true;
			});
			var listTHAds = items.filter((item) => {
				return (item.status === 'Enabled' && item.position === 'TH')
			});
			var listTLAds = items.filter((item) => {
				return (item.status === 'Enabled' && item.position === 'TL')
			});
			var listTRAds = items.filter((item) => {
				return (item.status === 'Enabled' && item.position === 'TR')
			});
			var listBLAds = items.filter((item) => {
				return (item.status === 'Enabled' && item.position === 'BL')
			});
			var listBRAds = items.filter((item) => {
				return (item.status === 'Enabled' && item.position === 'BR')
			});

			obj.setState({ listTHAds, listTLAds, listTRAds, listBLAds, listBRAds });
		});
	}

	componentDidMount() {
		var params = {
			therapistId: this.subCognito,
			type: 'active'
		};
		var data = stripeAPI("subscription/current", params);
        var $this = this;
        data.then(response => {
			var isShowAds = true;
			if(response.id && response.amount !== '0') {
				if(response.end_date) {
					var currentUnixTime = Math.round((new Date()).getTime() / 1000);
					if(currentUnixTime < response.end_date) {
						isShowAds = false;
					}
				}
			}

			if(!isShowAds) {
				$this.setState({ isShowAds });
			} else {
				$this.setState({ isShowAds });
				$this.loadAds();
				window.loadSlide();
			}
        }).catch(error => {
			$this.setState({ isShowAds: true });
			$this.loadAds();
			window.loadSlide();
        });
	}

	render() {
		const { listTHAds, listTLAds, listTRAds, listBLAds, listBRAds } = this.state;
		return (
			<section className="body">
				<Header listTHAds={listTHAds} />
				<div className="inner-wrapper">
					<Menu />
					<section role="main" className={`content-body ads-Top${listTLAds.length > 0 || listTRAds.length > 0 ? '' : ' ads-hide'}`}>
						<div className="row">
							<div className="col-lg-6 mb-3 ads-left">
								<section className="card">
									<div id="carouselExampleSlidesOnlyTR" className="carousel slide" data-ride="carousel">
										<div className="carousel-inner" role="listbox">
											{listTLAds.map((adv, i) => {
												return (<Ads adv={adv} i={i} key={i} />)
											})}
										</div>
									</div>
								</section>
							</div>
							<div className="col-lg-6 mb-3 ads-right">
								<section className="card">
									<div id="carouselExampleSlidesOnlyTL" className="carousel slide" data-ride="carousel">
										<div className="carousel-inner" role="listbox">
											{listTRAds.map((adv, i) => {
												return (<Ads adv={adv} i={i} key={i} />)
											})}
										</div>
									</div>
								</section>
							</div>
						</div>
					</section>
					{this.props.children}
					<section role="main" className={`content-body npt ads-Bottom${listBLAds.length > 0 || listBRAds.length > 0 ? '' : ' ads-hide'}`}>
						<div className="row">
							<div className="col-lg-6 mb-3 ads-left">
								<section className="card">
									<div id="carouselExampleSlidesOnlyBL" className="carousel slide" data-ride="carousel">
										<div className="carousel-inner" role="listbox">
											{listBLAds.map((adv, i) => {
												return (<Ads adv={adv} i={i} key={i} />)
											})}
										</div>
									</div>
								</section>
							</div>
							<div className="col-lg-6 mb-3 ads-right">
								<section className="card">
									<div id="carouselExampleSlidesOnlyBR" className="carousel slide" data-ride="carousel">
										<div className="carousel-inner" role="listbox">
											{listBRAds.map((adv, i) => {
												return (<Ads adv={adv} i={i} key={i} />)
											})}
										</div>
									</div>
								</section>
							</div>
						</div>
					</section>
				</div>
			</section>
		)
	}
}

export default MainLayout;
